import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Jumbotron } from 'react-bootstrap';


export default class ExpiredAccess extends Component {
    displayName = 'ExpiredAccess';

    constructor(props) {
        super(props);
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${this.props.auth.getAccessToken()}` }
        };

        this.state = {
            contactUsMailTo: "mailto: support@hindsightmetrics.com"
        };

        fetch(`api/AgencyService/${localStorage.getItem('agency_key')}/`, requestOptions)
            .then(response => response.json())
            .then(data => {

                this.setState({
                    loadedData: true,
                    agencyName: data.name,
                    contactUsMailTo: "mailto:" + process.env.REACT_APP_CONTACT_US_EMAIL + "?subject=Expired " + data.name

                });
            });
    }

    render() {
        return (
            <Jumbotron>
                <h2>
                    Account Access Expired
                    <br />
                    <small>For more information <a href={this.state.contactUsMailTo}> contact us</a></small>
                </h2>

                <Link to={'/'}
                    onClick={() => this.props.auth.logoutNoRedirect()}> Back to Log in</Link>

            </Jumbotron>
        );
    }

}


// WEBPACK FOOTER //
// ./src/components/Auth/ExpiredAccess.js